import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { createFile, uuid } from '@/views/visual/dataScreen/js/utils/utils';
export default {
  name: 'contentmenu',
  inject: ["contain"],
  data: function data() {
    return {
      contentMenu: false,
      contentMenuX: 0,
      contentMenuY: 0
    };
  },
  computed: {
    styleName: function styleName() {
      return {
        left: this.setPx(this.contentMenuX),
        top: this.setPx(this.contentMenuY)
      };
    }
  },
  methods: {
    show: function show() {
      var X = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var Y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.contentMenuX = X;
      this.contentMenuY = Y;
      this.contentMenu = true;
    },
    hide: function hide() {
      this.contentMenuX = 0;
      this.contentMenuY = 0;
      this.contentMenu = false;
    },
    handleStepBottom: function handleStepBottom() {
      this.handleCommon(false, true);
    },
    handleStepTop: function handleStepTop() {
      this.handleCommon(true, true);
    },
    //文件夹成组逻辑
    handleCompose: function handleCompose() {
      var _this = this;

      var list = this.contain.active;
      this.$confirm({
        title: '提示',
        content: "\u662F\u5426\u7EC4\u5408\u6240\u9009\u62E9\u7684\u56FE\u5C42?",
        onOk: function onOk() {
          var floder = createFile(); //查找到每个组件调用核心方法就行组合操作
          //寻找父类

          var params = _this.contain.findnav(list[0], true);

          list.forEach(function (ele) {
            var item = _this.contain.findnav(ele, true);

            item.parent.splice(item.count, 1);
            floder.children.push(item.obj);
          });
          params.parent.push(floder);
        }
      });
    },
    //文件夹解散逻辑
    handleLogout: function handleLogout() {
      var _this2 = this;

      var ele = this.contain.activeObj;
      this.$confirm({
        title: '提示',
        content: "\u662F\u5426\u89E3\u6563".concat(ele.name, "\u56FE\u5C42?"),
        onOk: function onOk() {
          var params = _this2.contain.findnav(ele.index, true);

          var list = _this2.deepClone(params.obj.children);

          params.parent.splice(params.count, 1);
          list.forEach(function (ele) {
            params.parent.push(ele);
          });

          _this2.contain.handleInitActive();
        }
      });
    },
    //删除组件的方法
    handleDel: function handleDel() {
      var _this3 = this;

      this.$confirm({
        title: '提示',
        content: "\u662F\u5426\u5220\u9664\u6240\u9009\u56FE\u5C42?",
        onOk: function onOk() {
          var params = _this3.contain.findnav(_this3.contain.active[0], true);

          _this3.contain.active.forEach(function (ele) {
            var item = _this3.contain.findnav(ele, true);

            if (Array.isArray(params.parent)) {
              params.parent.splice(item.count, 1);
            } else {
              params.parent.children.splice(item.count, 1);
            }
          });

          _this3.contain.handleInitActive();
        }
      });
    },
    //复制组件的方法
    handleCopy: function handleCopy() {
      var _this4 = this;

      //寻找父类
      var params = this.contain.findnav(this.contain.active[0], true);
      this.contain.active.forEach(function (ele) {
        var item = _this4.contain.findnav(ele, true);

        var obj = _this4.deepClone(item.obj);

        obj.index = uuid();
        params.parent.unshift(obj);
      });
      this.contain.handleInitActive();
    },
    // 图层的上下移动方法 
    handleCommon: function handleCommon() {
      var first = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      // 交换数组元素
      var swapItems = function swapItems(arr, index1, index2) {
        arr[index1] = arr.splice(index2, 1, arr[index1])[0];
        return arr;
      };

      var obj = this.contain.activeObj;
      var data = this.deepClone(obj);
      var params = this.contain.findnav(obj.index, true);

      if (params.pcount !== 0) {
        if (params.len < 1) return;

        if (step) {
          if (first && params.count === 0) return;
          if (!first && params.count === params.len) return;
          var count = first ? params.count - 1 : params.count + 1;
          swapItems(params.parent.children, params.count, count);
        } else {
          if (first) {
            if (params.count === 0) return;
            params.parent.children.splice(params.count, 1);
            params.parent.children.unshift(data);
          } else {
            if (params.count === params.len) return;
            params.parent.children.splice(params.count, 1);
            params.parent.children.push(data);
          }
        }
      } else {
        if (this.contain.nav.length < 1) return;

        if (step) {
          if (first && params.count === 0) return;
          if (!first && params.count === params.len) return;

          var _count = first ? params.count - 1 : params.count + 1;

          swapItems(this.contain.nav, params.count, _count);
        } else {
          if (first) {
            if (params.count === 0) return;
            this.contain.nav.splice(params.count, 1);
            this.contain.nav.unshift(data);
          } else {
            if (params.count === params.len) return;
            this.contain.nav.splice(params.count, 1);
            this.contain.nav.push(data);
          }
        }
      }
    },
    handleTop: function handleTop() {
      this.handleCommon(true);
    },
    handleBottom: function handleBottom() {
      this.handleCommon();
    },
    handleLock: function handleLock() {
      this.contain.activeObj.lock = !this.contain.activeObj.lock;
      this.contain.active = [];
    }
  }
};